import {Preferences} from '@capacitor/preferences';
import {Capacitor} from "@capacitor/core";

export const useStorage = () => {

  const setValue = async (key: string, value: string) => {
    if (Capacitor.isNativePlatform())
      await Preferences.set({key, value});
    else
      return localStorage.setItem(key, value);

  };

  const getValue = async (key: string): Promise<string | null> => {
    if (Capacitor.isNativePlatform())
      return (await Preferences.get({key}))?.value
    else
      return localStorage.getItem(key);

  }

  return {
    setValue,
    getValue
  }
}
